<div class="container-fluid disconnected-container d-flex flex-column">

  <div class="row disconnected-header justify-content-center align-items-center">
    <div class="col-12 text-center">
      <img src="assets/logo_qwintal.svg" alt="Logo" class="logo">
    </div>
  </div>


  <div class="row flex-grow-1 disconnected-main">

    <div class="col-12 col-md-12 d-flex justify-content-center align-items-center">
      <div class="w-100 p-4" style="max-width: 400px;">
        <form [formGroup]="forgotForm">

          <div class="mb-3 justify-content-center align-items-center forgot-text">
            <h2>Mot de passe oublié</h2>
            <h3>Vous avez perdu votre mot de passe ?<br /> Renseignez votre adresse e-mail pour recevoir
            un lien de réinitialisation.</h3>
          </div>
          <div class="mb-3 d-flex justify-content-center align-items-center">
            <nb-form-field>
              <nb-icon nbPrefix icon="q-utilisateur" pack="custom"></nb-icon>
              <input type="text" nbInput fullWidth shape="round" class="input-login" placeholder="E-mail" formControlName="email" required />
            </nb-form-field>
          </div>
          @if (error) {
            <div class="mb-2 d-flex justify-content-center align-items-center">
              <p class="error">Veuillez saisir un email valide.</p>
            </div>
          }
          <div class="form-group d-flex justify-content-center align-items-center">
            <button nbButton status="danger" shape="round" size="medium" class="submit-disconnect"   (click)="resetAction()"
              title="Réinitialiser" >Réinitialiser<nb-icon icon="q-fleche-droite" pack="custom"></nb-icon></button>
            </div>
            @if (sent) {
              <div class="mb-2 d-flex justify-content-center align-items-center">
                <p>Consultez vos e-mails pour réinitialiser votre mot de passe.</p>
              </div>
            }
            <div class="form-group d-flex justify-content-center align-items-center">
              <a [routerLink]="['/auth']">Retour</a>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="row disconnected-footer justify-content-center align-items-center">
      <div class="col-12 text-center">
        Visitez notre site <a href="https://www.qwintal.com" target="_blank">www.qwintal.fr</a>
      </div>
    </div>
  </div>
